<template>
  <div class="booking-container">
    <div class="booking" :key="reloadKey" v-if="configuration">
        <h1><span>{{messages.applicationTitle}}</span>
          <span class="countDown" v-if="showCountDown && reservedAppointmentId" style="float:right;">{{ reservationTimeoutCount | formatTimeFromSec }}</span>
        </h1>
        <v-expansion-panels v-model="currentExpansionPanelOpen" class="booking-wrapper" v-show="loaded">
          <component v-for="(step, index) in steps"
            :is="step.compStep"
            :key="index"
            v-show="step.show"
            :is-first="step.isFirst"
            :disabled="step.disabled"
            :process-number="step.processNumber"
            @data-selected="dataSelected"
            @check-steps="checkSteps"
            :load-calendar="loadCalendar"
            :display-selected-date-time="displaySelectedDateTime"
            @:update:display-selected-date-time="displaySelectedDateTime = $event"
            :load-mobile-verification="loadMobileVerification"
            :load-appointment-list.sync="loadAppointmentList"
            @reset-data="resetData"
            :start-page="startPage"
            :url-params="urlParams"
            @is-loaded='putLoadedOn'
            :id="'step'+ (index + 1)"
            @branches='getBranch'
            :webid="step.compStep"
            :current-panel-open="currentExpansionPanelOpen"
            :rereserve-timeslot-key="rereserveTimeslotKey"
            @cancel-timeout="closeTimeoutDialogAndClearReservationTimeout"
            :reservationExpired="reservationExpired"
          ></component>
      </v-expansion-panels>
      <!--v-container>
        <v-row>
          <v-col>reservation Timeout: {{reservationTimeoutCountPopup}}</v-col>
        </v-row>
      </v-container-->
      <v-container fluid v-if="!loaded">
        <v-row align-center justify-center row fill-height>
          <v-col>
          <v-progress-circular
              indeterminate
              :size="70"
              color="primary"
            ></v-progress-circular>
          </v-col>
        </v-row>
      </v-container>
      <TimeoutDialog v-if="configuration.allowReservationExtension"
        :show-timeout-dialog="showSlotReserveTimeoutDialog"
        :start-decount-key="startDecountSlotReserveTimeoutKey"
        :initial-count="configuration.reservationCountdownPopupDuration ? configuration.reservationCountdownPopupDuration : 30"
        @timed-out="slotReserveTimeoutTimedOut"
        @confirm="slotReserveTimeoutConfirm"
      ></TimeoutDialog>
    </div>
  </div>
</template>

<script>
import RestService from '../services/restService'
import DataService from '../services/dataService'
import ServiceSelection from '../components/ServiceSelection'
import BranchSelection from '../components/BranchSelection'
import DateTimeSelectionStep from '../components/DateTimeSelectionStep'
import ContactStep from '../components/ContactStep'
import TimeoutDialog from '../components/TimeoutDialog'
import { mapActions, mapState, mapGetters, mapMutations } from 'vuex'
import { eventHub } from '../utils/eventhub'

export default {
  name: 'Booking',
  props: [
    'startPage',
    'urlParams',
    'reloadKey'
  ],
  mixins: [RestService, DataService],
  components: {
    ServiceSelection,
    BranchSelection,
    DateTimeSelectionStep,
    ContactStep,
    TimeoutDialog
  },
  data: () => ({
    currentExpansionPanelOpen: 0,
    displaySelectedDateTime: false,
    loadCalendar: false,
    loadMobileVerification: false,
    loadAppointmentList: false,
    steps: [
      {
        compStep: null,
        show: true,
        isFirst: true,
        disabled: false,
        processNumber: 1
      }, {
        compStep: null,
        show: true,
        isFirst: false,
        disabled: true,
        processNumber: 2
      }, {
        compStep: null,
        show: true,
        isFirst: null,
        disabled: true,
        processNumber: 3
      }, {
        compStep: null,
        show: true,
        isFirst: null,
        disabled: true,
        processNumber: 4
      }
    ],
    loaded: false,
    showSlotReserveTimeoutDialog: false,
    startDecountSlotReserveTimeoutKey: 0,
    usingKeyboard: false,
    reservationTimeoutCountPopup: -1,
    myTimer: null,
    rereserveTimeslotKey: 1,
    branches: [],
    showCountDown: false,
    myCountdownTimer: null,
    reservationTimeoutCount: -1,
    reservationExpired: false
  }),
  computed: {
    ...mapState([
      'isServicesStepValid',
      'isBranchStepValid',
      'configuration',
      'selectedServices',
      'selectedBranch',
      'servicesTranslations',
      'branchTranslations',
      'selectedDate',
      'selectedTimeSlot',
      'contactDetails',
      'reservedAppointmentId',
      'preSelectedServices',
      'messages',
      'funcDebug'
    ]),
    ...mapGetters({
      totalCost: 'selectedServicesTotalCost',
      customSlotLength: 'customSlotLength',
      isDateTimeSelectionStepValid: 'isDateTimeSelectionStepValid'
    })
  },
  watch: {
    // this watch take care of the step focus by sending the step-focus event to the right step component
    currentExpansionPanelOpen () {
      if (this.funcDebug) console.log('Booking:watch:currentExpansionPanelOpen')
      if (this.currentExpansionPanelOpen) {
        // console.log(this.steps[this.currentExpansionPanelOpen].compStep)
        switch (this.steps[this.currentExpansionPanelOpen].compStep) {
          case 'serviceSelection':
            eventHub.$emit('service-step-focus')
            break
          case 'branchSelection':
            eventHub.$emit('branch-step-focus')
            break
          case 'dateTimeSelectionStep':
            eventHub.$emit('date-time-step-focus')
            break
          case 'contactStep':
            eventHub.$emit('contact-step-focus')
            break
        }
      }
    }
  },
  methods: {
    ...mapMutations([
      'setPreSelectedBranch',
      'setPreSelectedServices',
      'setPreSelectedServiceGroups'
    ]),
    ...mapActions([
      'resetSelectedDateAndTimeSlot',
      'resetBookingStore',
      'resetReservedAppointmentId'
    ]),
    checkSteps () {
      if (this.funcDebug) console.log('Booking:methods:checkSteps')
      // first find out if the user is using the keyboard or the mouse
      let classList = document.body.classList
      for (let i = 0; i < classList.length; i++) {
        if (classList[i].indexOf('keyboard') >= 0) {
          this.usingKeyboard = true
        }
      }
      let previousPanelOpen = this.currentExpansionPanelOpen
      if (this.funcDebug) console.log('usingKeyboard=' + this.usingKeyboard)
      this.steps[0].disabled = false
      // check validation of first step
      if ((this.steps[0].compStep === 'serviceSelection' && !this.isServicesStepValid) ||
        (this.steps[0].compStep === 'branchSelection' && !this.isBranchStepValid)) {
        // not valid then hide all but step one
        this.steps[1].disabled = true
        this.steps[2].disabled = true
        this.steps[3].disabled = true
        this.loadCalendar = false
        this.loadMobileVerification = false
        this.displaySelectedDateTime = false
        /* if(this.steps[0].compStep === 'serviceSelection' && !this.isServicesStepValid) { */
        this.currentExpansionPanelOpen = 0
        /* } */
      } else {
        // check validation of second step
        if ((this.steps[1].compStep === 'serviceSelection' && !this.isServicesStepValid) ||
          (this.steps[1].compStep === 'branchSelection' && !this.isBranchStepValid)) {
          // not valid then hide all after step 2
          this.steps[1].disabled = false
          this.steps[2].disabled = true
          this.steps[3].disabled = true
          this.loadCalendar = false
          this.loadMobileVerification = false
          this.displaySelectedDateTime = false
          if (this.steps[0].compStep === 'serviceSelection') {
            // The first step is service selection, it has a valid service selection, but
            // the services selection panel should still stay open as the customer
            // might want to add more adults/children/services
            // but if services are preselected and multiplePeopleEnabled is not active, then go to this step anyway
            // and if no multiselection and multiplePeopleEnabled is not active, then go to this step too
            if (((this.preSelectedServices.length > 0 || !this.configuration.multipleServicesEnabled) && !this.configuration.multiplePeopleEnabled) || (!this.configuration.multipleServicesEnabled && (this.configuration.multiplePeopleEnabled && this.configuration.multiplePeopleHideNoDuration && !this.selectedServices[0].additionalDuration))) {
              // If customer is using the keyboard, always stay on the same panel, as they need to go
              // through all the branches using the arrow keys or the space
              if (this.usingKeyboard) {
                this.currentExpansionPanelOpen = previousPanelOpen
              } else {
                this.currentExpansionPanelOpen = 1
              }
            } else {
              this.currentExpansionPanelOpen = previousPanelOpen
            }
          } else {
            // First step is branch, so go to the service panel if using the mouse
            if (this.usingKeyboard) {
              this.currentExpansionPanelOpen = previousPanelOpen
            } else {
              this.currentExpansionPanelOpen = 1
            }
          }
        } else {
          // check validity of third step
          if (!this.isDateTimeSelectionStepValid) {
            this.steps[3].disabled = true
          }
          this.steps[1].disabled = false
          this.steps[2].disabled = false
          this.loadCalendar = true
          if (this.steps[1].compStep === 'serviceSelection' || (this.steps[0].compStep === 'serviceSelection' && !this.showSingleBranch)) {
            // The second step is service selection (or the first one and the branch selection is not shown),
            // and it is valid. But it might still be the case that the customer wants to add more adults/children/services,
            // so leave it expanded. But if services are preselected and multiplePeopleEnabled is not active, then go to this step anyway
            if (((this.preSelectedServices.length > 0 || !this.configuration.multipleServicesEnabled) && !this.configuration.multiplePeopleEnabled) || (!this.configuration.multipleServicesEnabled && (this.configuration.multiplePeopleEnabled && this.configuration.multiplePeopleHideNoDuration && !this.selectedServices[0].additionalDuration))) {
              if (this.usingKeyboard) {
                this.currentExpansionPanelOpen = previousPanelOpen
              } else {
                this.currentExpansionPanelOpen = 2
              }
            } else {
              if (((this.isServicesStepValid && this.isBranchStepValid) && !this.configuration.multipleServicesEnabled && !this.configuration.multiplePeopleEnabled)) {
                // if service and branch selected open date and time expansion panel
                if (this.usingKeyboard) {
                  this.currentExpansionPanelOpen = previousPanelOpen
                } else {
                  this.currentExpansionPanelOpen = 2
                }
              }
            }
          } else {
            if (this.usingKeyboard) {
              this.currentExpansionPanelOpen = previousPanelOpen
            } else {
              this.currentExpansionPanelOpen = 2
            }
          }
        }
      }
    },
    getBranch (branches) {
      // get branches retrieved from branch selection component
      let branchCount = branches.length
      if (branchCount === 1) {
        this.branches = branches
      }
      this.checkUrlParams()
    },
    dataSelected (componentType) {
      if (this.funcDebug) console.log('Booking:methods:dataSelected')
      if (componentType === 'branch' || componentType === 'services') {
        this.resetTimeslotReservation()
        this.resetSelectedDateAndTimeSlot()
        this.checkSteps()
      } else if (componentType === 'date-time') {
        // a timeslot has been reserved, init timout
        this.initializeReservationTimeoutPopup()
        this.initializeReservationTimeCounter()
        this.steps[3].disabled = false
        this.displaySelectedDateTime = true
        this.loadMobileVerification = true
        this.currentExpansionPanelOpen = 3
      } else { }
    },
    checkUrlParams () {
      if (this.funcDebug) console.log('Booking:methods:checkUrlParams')
      // check if url is restricted to branch/service only
      if (this.configuration.restrictUrl) {
        if (!this.$route.params.branchId && !this.$route.params.serviceId) {
          if (this.funcDebug) console.log('Booking:URL restricted')
          this.$router.push('404')
          return false
        }
      }
      switch (this.$route.name) {
        case 'servicebooking':
          // services preselected
          this.steps[0].compStep = 'serviceSelection'
          this.steps[1].compStep = 'branchSelection'
          if (this.$route.params.serviceId.split(',').length === 1) {
            // one service, should we show it, check the option
            if (this.configuration && (!this.configuration.showSingleService && !this.configuration.multiplePeopleEnabled)) {
              // don't show it
              this.steps[0].show = false
              this.steps[1].processNumber = 1
              this.steps[2].processNumber = 2
              this.steps[3].processNumber = 3
            }
          }
          // get the preselected services
          this.setPreSelectedServices(this.$route.params.serviceId.split(','))
          break
        case 'branchbooking':
          // branch preselected
          this.steps[0].compStep = 'branchSelection'
          this.steps[1].compStep = 'serviceSelection'
          // check if we need to show the branch
          if (this.configuration && !this.configuration.showSingleBranch) {
            // don't show it
            this.steps[0].show = false
            this.steps[1].processNumber = 1
            this.steps[2].processNumber = 2
            this.steps[3].processNumber = 3
          }
          // get the preselected branch
          this.setPreSelectedBranch(this.$route.params.branchId)
          break
        case 'calendarbooking':
          let showServiceStep = this.configuration &&
                                (this.configuration.multiplePeopleEnabled ||
                                (this.configuration.showSingleService && this.$route.params.serviceId.split(',').length === 1) ||
                                this.$route.params.serviceId.split(',').length !== 1)
          let showBranchStep = this.configuration && this.configuration.showSingleBranch
          // if both steps are off
          if (!showServiceStep && !showBranchStep) {
            this.steps[0].compStep = 'branchSelection'
            this.steps[0].show = false
            this.steps[1].compStep = 'serviceSelection'
            this.steps[1].show = false
            this.steps[2].processNumber = 1
            this.steps[3].processNumber = 2
          } else {
            // TODO always put branch first and ignore this.configuration.serviceFirst GP-3487
            if (this.configuration && this.configuration.serviceFirst) {
              // service is first
              this.steps[0].compStep = 'serviceSelection'
              this.steps[1].compStep = 'branchSelection'
              if (!showServiceStep) {
                this.steps[0].show = false
                this.steps[1].processNumber = 1
                this.steps[2].processNumber = 2
                this.steps[3].processNumber = 3
              }
              if (!showBranchStep) {
                this.steps[1].show = false
                this.steps[2].processNumber = 2
                this.steps[3].processNumber = 3
              }
            } else {
              // branch is first
              this.steps[0].compStep = 'branchSelection'
              this.steps[1].compStep = 'serviceSelection'
              if (!showBranchStep) {
                this.steps[0].show = false
                this.steps[1].processNumber = 1
                this.steps[2].processNumber = 2
                this.steps[3].processNumber = 3
              }
              if (!showServiceStep) {
                this.steps[1].show = false
                this.steps[2].processNumber = 2
                this.steps[3].processNumber = 3
              }
            }
          }
          // services and branch preselected
          this.setPreSelectedBranch(this.$route.params.branchId)
          this.setPreSelectedServices(this.$route.params.serviceId.split(','))
          break
        case 'servicegroupsbooking':
          if (this.configuration && this.configuration.serviceFirst) {
            this.steps[0].compStep = 'serviceSelection'
            this.steps[1].compStep = 'branchSelection'
          } else {
            this.steps[0].compStep = 'branchSelection'
            this.steps[1].compStep = 'serviceSelection'
          }
          // servicegroup preselected
          this.setPreSelectedServiceGroups(this.$route.params.serviceGroups.split(','))
          break
        case 'branchandservicegroupsbooking':
          // always set branch to first step in this case, as one branch is preselected
          this.steps[0].compStep = 'branchSelection'
          this.steps[1].compStep = 'serviceSelection'
          // check if we need to display branches
          if (this.configuration && !this.configuration.showSingleBranch) {
            this.steps[0].show = false
            this.steps[1].processNumber = 1
            this.steps[2].processNumber = 2
            this.steps[3].processNumber = 3
          }
          // branch preselected
          this.setPreSelectedBranch(this.$route.params.branchId)
          // servicegroup preselected
          this.setPreSelectedServiceGroups(this.$route.params.serviceGroups.split(','))
          break
        default:
          if (this.configuration && this.configuration.serviceFirst) {
            this.steps[0].compStep = 'serviceSelection'
            this.steps[1].compStep = 'branchSelection'
          } else {
            this.steps[0].compStep = 'branchSelection'
            this.steps[1].compStep = 'serviceSelection'
          }
          break
      }
      this.steps[2].compStep = 'dateTimeSelectionStep'
      this.steps[3].compStep = 'contactStep'

      // if only one branch and not show single branch
      if (typeof this.branches !== 'undefined' && this.branches.length > 0) {
        // if only one branch and not show single branch
        if (!this.configuration.showSingleBranch && (this.branches.length === 1 && this.steps[0].compStep === 'branchSelection')) {
          this.steps[0].show = false
          this.steps[1].processNumber = 1
          this.steps[2].processNumber = 2
          this.steps[3].processNumber = 3
        }
        if ((this.configuration.autoSingleBranch || !this.configuration.showSingleBranch) && (this.branches.length === 1 && this.steps[0].compStep === 'branchSelection')) {
          this.setPreSelectedBranch(this.branches[0].id)
        }
      }
    },
    resetTimeslotReservation () {
      if (this.funcDebug) console.log('Booking:methods:resetTimeslotReservation')
      if (this.reservedAppointmentId) {
        const myReservedAppointmentId = this.reservedAppointmentId
        this.resetReservedAppointmentId()
        this.releaseTimeslot(myReservedAppointmentId).then(response => {
          if (this.funcDebug) console.log('Booking:resetTimeslotReservation:releaseTimeslot.then')
        })
        this.clearReservationTimeout()
        this.initializeReservationTimeCounter()
      }
    },
    resetData (showTimeoutMessage = false) {
      if (this.funcDebug) console.log('Booking:methods:resetData')
      this.panel = []
      if (this.reservedAppointmentId) {
        this.releaseTimeslot(this.reservedAppointmentId).then(response => {
          if (this.funcDebug) console.log('Booking:resetData:releaseTimeslot.then')
        })
        this.clearReservationTimeout()
      }
      this.resetBookingStore()
      Object.assign(this.$data, this.$options.data.call(this))
      this.checkUrlParams()
      this.checkSteps()
      // force reload the complete form
      this.$emit('increase-reload-key')
      if (showTimeoutMessage) {
        eventHub.$emit('show-info', this.messages.reservationTimeoutDialogExpired)
      } else {
        // remove all messages
        eventHub.$emit('hide-message')
      }
    },
    putLoadedOn () {
      if (this.funcDebug) console.log('Booking:methods:putLoadedOn')
      this.loaded = true
    },
    slotReserveTimeoutTimedOut () {
      if (this.funcDebug) console.log('Booking:methods:slotReserveTimeoutTimedOut')
      this.showSlotReserveTimeoutDialog = false
      this.resetData(true)
    },
    slotReserveTimeoutConfirm () {
      if (this.funcDebug) console.log('Booking:methods:SlotReserveTimeoutConfirm')
      this.rereserveTimeslotKey++
      this.showSlotReserveTimeoutDialog = false
    },
    openSlotReserveTimoutDialog () {
      this.showSlotReserveTimeoutDialog = true
      this.startDecountSlotReserveTimeoutKey++
    },
    initializeReservationTimeoutPopup () {
      if (this.funcDebug) console.log('Booking:methods:initializeReservationTimeoutPopup')
      const reservationCountdownPopupDuration = this.configuration.reservationCountdownPopupDuration ? this.configuration.reservationCountdownPopupDuration : 30
      const reservationExpiryTimeSeconds = this.configuration.reservationExpiryTimeSeconds ? this.configuration.reservationExpiryTimeSeconds : 600
      this.reservationTimeoutDecount(reservationExpiryTimeSeconds - reservationCountdownPopupDuration - 10)
    },
    initializeReservationTimeCounter () {
      if (this.funcDebug) console.log('Booking:methods:initializeReservationTimeCounter')
      if (this.configuration.showCountdown) {
        this.showCountDown = true
      }
      this.expiryTimeDecount(this.configuration.reservationExpiryTimeSeconds ? this.configuration.reservationExpiryTimeSeconds : 600)
    },
    closeTimeoutDialogAndClearReservationTimeout () {
      if (this.funcDebug) console.log('Booking:methods:closeTimeoutDialogAndClearReservationTimeout')
      this.showSlotReserveTimeoutDialog = false
      this.clearReservationTimeout()
    },
    clearReservationTimeout () {
      if (this.funcDebug) console.log('Booking:methods:clearReservationTimout')
      clearTimeout(this.myTimer)
      // this.reservationTimeoutCountPopup = -1
    },
    reservationTimeoutDecount (initialCount) {
      if (this.funcDebug) console.log('Booking:methods:reservationTimeoutDecount')
      if (initialCount) {
        this.reservationTimeoutCountPopup = initialCount
      } else {
        this.reservationTimeoutCountPopup--
      }
      if (this.reservationTimeoutCountPopup > 0) {
        clearTimeout(this.myTimer)
        this.myTimer = setTimeout(() => {
          this.reservationTimeoutDecount()
        }, 1000)
      } else {
        this.openSlotReserveTimoutDialog()
      }
    },
    expiryTimeDecount (initialCount) {
      if (this.funcDebug) console.log('Booking:methods:expiryTimeDecount')
      if (initialCount) {
        this.reservationExpired = false
        this.reservationTimeoutCount = initialCount
      } else {
        this.reservationTimeoutCount--
      }
      if (this.reservationTimeoutCount > 0) {
        clearTimeout(this.myCountdownTimer)
        this.myCountdownTimer = setTimeout(() => {
          this.expiryTimeDecount()
        }, 1000)
      } else {
        // make sure the book appointment button is not enabled
        this.reservationExpired = true
      }
    }
  },
  mounted () {
    if (this.funcDebug) console.log('Booking:mounted')
    this.loaded = false
    this.checkUrlParams()
  }
}
</script>

<style lang="scss">
.booking h1 {
  padding-bottom: 24px;
  background-color: var(--wrapper-bg-color-primary) !important;
  font-weight:300;
}

.booking-wrapper {
  box-shadow: none;
  background-color: var(--wrapper-bg-color-primary) !important;
}

/*.v-expansion-panel-header.process-step-header.v-expansion-panel-header--active{
  background-color: var(--primary-color) !important;
}*/

.booking-wrapper .process-step-header .process-step-name {
  text-transform: uppercase;
  line-height: 40px;
  font-size: 24px;
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  letter-spacing: normal;
  color: var(--process-step-name-text-color);
  width: 90%;

  @at-root [dir="rtl"] & {
    padding-left: 0;
    padding-right: 24px;
  }
}

.process-step-header .v-expansion-panel-header__icon .v-icon.mdi.theme--light {
  color: var(--primary-bg-text-color) !important;
  font-size: 36px;
}

// icons on select expansions panels
.selected .v-icon.mdi{
  color: var(--primary-bg-text-color) !important;
}

.booking-wrapper .v-expansion-panels .v-expansion-panel-header:focus{
  background-color: #e5e5e5 !important;
}
.booking-wrapper
  .v-expansion-panel__container.process-step-header.v-expansion-panel__container:focus
  .process-step-name {
  text-decoration: underline;
}
.booking-wrapper
  .v-expansion-panel--disabled .v-expansion-panel-header.process-step-header{
  background-color:var(--not-focused-element) !important;
}

.booking-wrapper
  .process-step-header.v-expansion-panel-header .process-number{
    background-color: var(--process-step-number-bg);
  }

.booking-wrapper
  .process-step-header.v-expansion-panel-header--active .process-number{
  background-color: var(--process-step-number-bg);
}

.booking-wrapper .v-expansion-panel--disabled .v-expansion-panel-header.process-step-header .process-number{
  background-color: var(--not-focused-process-step-number-bg);
}

.choose-wrapper {
  padding: 0 24px 0 8px;

  @at-root [dir="rtl"] & {
    text-align: right;
  }
}

.chosen-options {
  /*position: absolute;
  right: 75px;
  bottom: 24px;*/
  /*margin-left: 25px;*/

  @at-root [dir="rtl"] & {
    margin-right: 65px;
  }
}

.process-number {
  font-size: 24px;
  background-color: var(--process-step-number-bg);
  line-height: 40px;
  width: 40px;
  height: 40px;
  border-radius: 50%;
  text-align: center;
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  letter-spacing: normal;
  text-align: center;
  color: var(--process-step-number-text-color);
}

.service-total-cost {
  font-weight: 700;
  position: absolute;
  bottom: 16px;
  right: 24px;
  color: rgba(0,0,0,.87);

  @at-root [dir="rtl"] & {
    right: auto;
    left: 24px;
  }
}

.amount-of {
  width: 150px;
  display: flex;
}

.countDown{
    float: right;
    background-color: orange;
    color: white;
    width: 100px;
    text-align: center;
  }

.theme--light.v-expansion-panel
  .v-expansion-panel__container.service-expansion-panel {
  color: var(--default-font-color) !important;
}

/*.theme--light.v-expansion-panel
  .v-expansion-panel__container.service-expansion-panel:focus
  .v-expansion-panel__header
  .v-expansion-panel__header__icon
  .v-icon.material-icons.theme--light {
  color: var(--focused-element) !important;
}
*/

/*
.theme--light.v-expansion-panel
  .v-expansion-panel__container.service-expansion-panel:focus
  .v-expansion-panel__header {
  color: var(--focused-element) !important;
}
*/

.service-expansion-panel
  .v-expansion-panel__header
  .v-expansion-panel__header__icon
  .v-icon.material-icons.theme--light {
  font-size: 24px;
  color: var(--default-font-color) !important;
}

.service-expansion-panel.selected
  .v-expansion-panel__header
  .v-expansion-panel__header__icon
  .v-icon.material-icons.theme--light {
  font-size: 24px;
  color: var(--primary-btn-text-color) !important;
}

.services-wrapper .service-expansion-panel .service-chkbox,
.services-wrapper .service-expansion-panel .service-chkbox .v-input__slot,
.services-wrapper
  .service-expansion-panel
  .v-input--selection-controls
  .v-input__slot {
  padding: 0;
  flex: none;
}

.services-wrapper
  .service-expansion-panel
  .service-chkbox
  .v-input__control
  .v-messages,
.services-wrapper .service-expansion-panel .v-input__control .v-messages {
  display: none;
}

.services-wrapper
  .service-expansion-panel
  .service-name
  .service-chkbox
  // .v-icon.material-icons.theme--light.accent--text,
// form .info-text .v-icon.material-icons.theme--light.accent--text
{
  color: var(--primary-btn-text-color) !important;
}

form {
  padding: 16px 0;
}

.v-input.input-field.v-text-field.phone-input {
  padding-top: 0px !important;
  position: relative;
  margin: 0;
  padding: 0 28px 0 12px;

  @at-root [dir="rtl"] & {
    margin-left: 0;
    margin-right: 0;
    padding: 0 12px 0 28px;
  }
}

.v-input.input-field.v-text-field.countrycode-input {
  padding-top: 0px !important;
  position: relative;
  margin: 0;
  padding: 0 12px 0 0;

  @at-root [dir="rtl"] & {
    margin-left: 24px;
    margin-right: 0;
    padding-left: 12px;
    padding: 0 0 0 12px;
  }
}

.flex {
  display: flex;
}

.total-cost {
  font-weight: 700;
}

.info-text-strong {
    font-family: CustomQWBFont, Roboto;
    font-size: 20px;
    font-weight: 500;
    font-style: normal;
    font-stretch: normal;
    line-height: normal;
    letter-spacing: 0.25px;
    color: var(--default-font-color);
}

.v-input.input-field.v-text-field {
  margin: 0 0 0 24px;
  width: 550px;

  @at-root [dir="rtl"] & {
    margin: 0 24px 0 0;
  }
}

.v-text-field .v-label {
  top: 10px;
}

.fields-wrapper {
  position: relative;
}

.v-alert.v-alert {
  border: none;
  width: 100%;
  margin-bottom: 8px;
}

.v-alert {
  margin-bottom: 8px;
  > div {
    @at-root [dir="rtl"] & {
      text-align: right;
    }
  }
  &__icon {
    @at-root [dir="rtl"] & {
      margin-right: 0;
      margin-left: 16px;
    }
  }
}

.fields-wrapper .phone-verification-btn.v-btn {
  height: 48px;
  background-color: var(--primary-btn-bg-color) !important;
  font-weight: 400;
  color: var(--primary-btn-text-color) !important;
  top: 0;
  margin-top: 0;
  border-radius: 2px;

  @at-root [dir="rtl"] & {
    margin-right: 0;
    margin-left: 0;
  }
}

.v-input--selection-controls.v-input .v-label {
  font-weight: normal;
  letter-spacing: 0.5px;
  //color: var(--default-font-color);
}

form .submit.v-btn.v-btn--text.theme--light {
  margin: 10px 24px;

  @at-root [dir="rtl"] & {
    display: flex;
  }
}
.reset-btn.v-btn.v-btn--icon.theme--light {
  position: absolute;
  top: 0;
  right: 0;
  margin: 16px 24px 0 0;
  font-weight: 400;
  font-size: 17px;
  width: auto;
  margin: 16px 24px 0 0;
  padding: 0 16px;
  background-color:var(--reset-btn-bg-color) !important;
  color: var(--reset-btn-text-color) !important;
  border: 1px solid var(--reset-btn-border-color) !important;
  border-radius: 0;
  height: 44px;
  @at-root [dir="rtl"] & {
    left: 0;
    right: auto;
    margin: 16px 0 0 24px;
  }
}

.reset-btn.v-btn.v-btn--icon.theme--light:hover{
  background-color: var(--defined-focused-element) !important;
  color: var(--primary-btn-text-color) !important;
}

.notification-type {
  padding: 10px 24px;
}

/*
.v-card__text {
  padding: 16px !important;
}
*/

/*
.v-card__subtitle, .v-card__text {
  font-size: inherit;
}
*/

.theme--light.v-card > .v-card__text, .theme--light.v-card .v-card__subtitle, .theme--light legend > span {
  color: rgba(0,0,0,.87);
}

.v-text-field .v-label--active{
  top:22px;
  font-size: 90%;
}

.v-text-field .v-label--active.primary--text{
  color: var(--input-label-text-color-focus) !important;
}

.v-text-field {
    padding-top:0;
}
.v-text-field__details {
  margin-bottom: 8px;
  padding:0 12px;
}

@media only screen and (max-width: 599px) {
  .booking-wrapper .process-step-header .process-step-name {
      font-size: 18px;
      line-height: 26px;
  }
  @media only screen and (max-width: 359px) and (min-width: 300px) {
    .process-number {
      line-height: 35px;
      height: 35px;
      width: 35px;
    }

    .v-card__text.flex {
      display: block;
    }

    .booking-wrapper .process-step-header .process-step-name {
      font-size: 16px;
      line-height: 35px;

      @at-root [dir="rtl"] & {
        padding-left: 0;
        padding-right: 10px;
      }
    }
  }

  .booking h1 {
    padding-bottom: 16px;
  }

  .v-expansion-panel-header {
    padding: 12px;
  }

  .choose-wrapper {
    padding: 0;
  }

  .amount-of {
    width: auto;
  }

  .amount-of .number {
    min-width: 35px;
  }

  .service-total-cost {
    bottom: 0;
    right: 16px;

    @at-root [dir="rtl"] & {
      right: auto;
      left: 16px;
    }
  }

  // .chosen-options {
  //   /*position: static;*/
  // }

  .info-text {
    padding: 8px;
  }

  .v-input.input-field.v-text-field {
    padding: 0 16px;
    width: 100%;
    margin: 0;

    @at-root [dir="rtl"] & {
      margin: 0;
    }
  }

  .v-text-field .v-label {
    font-size: 12px;
    height: 40px;
    white-space: normal;
    top:6px;
    max-width: 100%;
  }

  .v-input.input-field.v-text-field.phone-input {
    width: 100%;
    position: static;
    margin: 0;

    @at-root [dir="rtl"] & {
      margin-left: 0;
      margin-right: 0;
    }
  }

  .info-text.agreement {
    width: 100%;
    padding: 30px;
  }

  form {
    padding: 0 0 16px 0;
  }
  .reset-btn.v-btn.v-btn--icon.theme--light {
    margin-right: 16px;
    font-size: 16px;
    @at-root [dir="rtl"] & {
      left: 0;
      right: auto;
      margin: 16px 0 0 16px;
    }
  }

  form .submit.v-btn.v-btn--text.theme--light {
    display: block;
    width: auto;
    margin: 16px;
  }

  .services-wrapper
    .service-expansion-panel
    .v-input--radio-group--column
    .v-radio.service-chkbox {
    width: auto;
    margin-left: 16px;
  }

  .fields-wrapper .phone-verification-btn.v-btn {
    position: relative;
    display: block;
    margin-left: 16px;
    height: 52px;
    left: auto;

    @at-root [dir="rtl"] & {
      margin-left: 0;
      margin-right: 0;
      right: auto;
    }
  }
}

@media screen and (min-width: 600px) and (max-width: 751px) {
  .fields-wrapper .phone-verification-btn.v-btn {
    position: relative;
    display: block;
    margin-left: 24px;
    left: auto;

    @at-root [dir="rtl"] & {
      margin-left: 8px;
      margin-right: 24px;
      right: auto;
    }
  }

  .custom-field{
      width: auto !important;
      margin: 0 24px 0 24px !important;
  }

  .v-input.input-field.v-text-field {
    margin: 0 24px 0 24px;
    width: auto;

    @at-root [dir="rtl"] & {
      margin: 0 24px 0 24px;
    }
  }

  .v-input.input-field.v-text-field.phone-input {
    width: auto;
  }
}
@media all and (-ms-high-contrast: none), (-ms-high-contrast: active) {
  /* IE10+ CSS styles go here */
  .fields-wrapper .v-input .v-input__control {
    width: auto;
  }

  .agreement .v-input__control{
    width: 100% !important;
  }

  .v-input{
    display: block;
  }

  .v-text-field .v-label--active{
    top:4px !important;
    width: 90%;
  }
  .v-expansion-panel-content {
    display: inline;
  }
}

</style>
